module.exports = __webpack_public_path__ + "static/media/logo198.d22d0023.png";